var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PreOrderFilter'),_vm._l((_vm._preOrders),function(preOrder){return _c('PreOrder',{key:preOrder.id,attrs:{"preOrder":preOrder}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }